import { render } from "./yeni-slider-ekle.vue?vue&type=template&id=39d0777b"
import script from "./yeni-slider-ekle.vue?vue&type=script&lang=js"
export * from "./yeni-slider-ekle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__